import { calendarEntry, marketingCalendarEntryInput } from "./calendar-entry";

export const createCalendarEntry = {
  name: "createCalendarEntry" as const,
  input: marketingCalendarEntryInput,
  output: calendarEntry,
};
